import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const fetchDashboardCountAssociate = createAsyncThunk(
  "community/fetchDashboardCountAssociate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/dashboard-count-associate-manager/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);